// import { fetch_price_quotes } from '@ducat-unit/core/fetch';

import { MIN_COL_RATE } from '@/constants';
import { getHealthFactor } from '@/utils/getHealthFactor';

export function computeHealthFactor_borrow({
  btcInVault,
  btcPrice,
  unitInVault,
  unitAmountBorrow,
}: {
  btcInVault: number;
  btcPrice: number;
  unitInVault: number;
  unitAmountBorrow: number;
}) {
  const before = Number.parseFloat((((btcInVault * btcPrice) / unitInVault) * 100).toFixed(0));
  const after = Number.parseFloat((((btcInVault * btcPrice) / (unitInVault + unitAmountBorrow)) * 100).toFixed(0));

  return {
    healthFactorBefore: Number.isFinite(before) ? before : 1,
    healthFactorAfter: Number.isFinite(after) ? after : 1,
    healthStatusBefore: getHealthFactor(before),
    healthStatusAfter: getHealthFactor(after),
  };
}

export function computeHealthFactor_deposit({
  btcInVault,
  btcPrice,
  unitInVault,
  amountBtc,
}: {
  btcInVault: number;
  btcPrice: number;
  unitInVault: number;
  amountBtc: number;
}) {
  const before = Number.parseFloat((((btcInVault * btcPrice) / unitInVault) * 100).toFixed(0));

  const after = Number.parseFloat(((((btcInVault + amountBtc) * btcPrice) / unitInVault) * 100).toFixed(0));

  return {
    healthFactorBefore: Number.isFinite(before) ? before : 1,
    healthFactorAfter: Number.isFinite(after) ? after : 1,
    healthStatusBefore: getHealthFactor(before),
    healthStatusAfter: getHealthFactor(after),
  };
}

export function computeHealthFactor_repay({
  btcInVault,
  btcPrice,
  unitInVault,
  unitAmountRepay,
}: {
  btcInVault: number;
  btcPrice: number;
  unitInVault: number;
  unitAmountRepay: number;
}) {
  const before = Number.parseFloat((((btcInVault * btcPrice) / unitInVault) * 100).toFixed(0));

  const after = Number.parseFloat((((btcInVault * btcPrice) / (unitInVault - unitAmountRepay)) * 100).toFixed(0));

  return {
    healthFactorBefore: Number.isFinite(before) ? before : 1,
    healthFactorAfter: Number.isFinite(after) ? after : 1,
    healthStatusBefore: getHealthFactor(before),
    healthStatusAfter: getHealthFactor(after),
  };
}

export function computeHealthFactor_withdraw({
  btcInVault,
  btcPrice,
  unitInVault,
  amountBtc,
}: {
  btcInVault: number;
  btcPrice: number;
  unitInVault: number;
  amountBtc: number;
}) {
  const before = Number.parseFloat((((btcInVault * btcPrice) / unitInVault) * 100).toFixed(0));

  const after = Number.parseFloat(((((btcInVault - amountBtc) * btcPrice) / unitInVault) * 100).toFixed(0));

  return {
    healthFactorBefore: Number.isFinite(before) ? before : 1,
    healthFactorAfter: Number.isFinite(after) ? after : 1,
    healthStatusBefore: getHealthFactor(before),
    healthStatusAfter: getHealthFactor(after),
  };
}

export type Utxo = {
  txid: string;
  vout: number;
  value: number;
  script: string;
};

/*
// Deprecated
export function getOpCostDeposit(feeRate: number, utxos?: Utxo[]): number {
  const vinAllowanceSats = utxos ? calculateVinAllowance(utxos, feeRate) : VIN_ALLOWANCE * feeRate;
  const vault_deposit_config: VaultDepositConfig = {
    deposit_amount: 0,
    sats_address: '',
    tx_feerate: feeRate,
  };
  const tx_quote = VaultAPI.deposit.get_quote(vault_deposit_config);
  return tx_quote.total_cost + vinAllowanceSats;
}

// Deprecated
export function getOpCostWithdraw(feeRate: number): number {
  const vault_withdraw_config: VaultWithdrawConfig = {
    change_amount: 0,
    sats_address: '',
    tx_feerate: feeRate,
  };

  const tx_quote = VaultAPI.withdraw.get_quote(vault_withdraw_config);

  return tx_quote.total_cost;
}
*/

export function getOpCostRepay(feeRate: number): number {
  return 10000;
  // const vault_repay_config: VaultRepayConfig = {
  //   deposit_amount: 0,
  //   repay_amount: 0,
  //   unit_address: '',
  //   sats_address: '',
  //   unit_postage: 10000,
  //   tx_feerate: feeRate,
  // };

  // const tx_quote = VaultAPI.repay.get_quote(vault_repay_config);

  // return tx_quote.total_cost;
}

export function getOpCostRepo(feeRate: number, vault_count: number, utxos?: Utxo[]): number {
  return 10000;
  // if (vault_count === 0) {
  //   return 0;
  // }
  // const vinAllowanceSats = utxos ? calculateVinAllowance(utxos, feeRate) : VIN_ALLOWANCE * feeRate;
  // const tx_quote = VaultAPI.repo.get_tx_quote(
  //   {
  //     deposit_amount: 0,
  //     tx_feerate: feeRate,
  //   } as VaultRepoConfig,
  //   vault_count,
  // );

  // return tx_quote.total_cost + vinAllowanceSats;
}

export function getMaxUnit(btc: number, bitcoinPrice: number | undefined): number | null {
  if (!bitcoinPrice || !btc) {
    return null;
  }

  return Math.floor(Number((btc * bitcoinPrice) / MIN_COL_RATE));
}

export function getMaxUnitRounded(btc: number, bitcoinPrice: number | undefined): number | null {
  const maxBalance = getMaxUnit(btc, bitcoinPrice);

  return maxBalance && Math.floor(maxBalance);
}

/*
export async function fetchPriceQuote(liquidationPrice: number): Promise<PriceQuote> {
  const th = Math.floor(liquidationPrice);
  const quoteRes = await OracleAPI.quote.fetch_price_quote(QUOTE_SERVER_URL, th === 0 ? 1 : th);
  const quoteRes = await fetch_price_quotes(QUOTE_SERVER_URL);

  if (quoteRes.status !== 200) {
    throw new Error('Error fetching price quote');
  }

  const priceQuoteData: PriceQuote = quoteRes.data;
  return formatQuoteData(priceQuoteData);

  return quoteRes.data;
}
  */

// function formatQuoteData(priceQuoteData: any): PriceQuote {
//   return {
//     event_origin: null,
//     event_price: null,
//     event_stamp: null,
//     event_type: '',
//     latest_origin: '',
//     latest_price: priceQuoteData.curr_price,
//     latest_stamp: priceQuoteData.quote_stamp,
//     quote_origin: '',
//     srv_network: 'mutinynet',
//     srv_pubkey: priceQuoteData.oracle_pk,
//     ...priceQuoteData,
//   };
// }

/*
Data:
{
    "curr_price": 106762,
    "curr_stamp": 1751377200,
    "quote_price": 106762,
    "quote_stamp": 1751377200,
    "stop_price": null,
    "stop_stamp": null,
    "is_expired": false,
    "oracle_pk": "0348d6773f06f5138861d60d92558d21582d19034dfaf0c2fd7b88f2471dff26cf",
    "thold_hash": "a13cc61ebbd4f90bd5ac1592f2e8790712f9e18b",
    "thold_price": 53632,
    "thold_key": null,
    "req_id": "67cb466934a639fff9286e3263128603905af0a76c294a84397721efac9bc965",
    "req_sig": "3045022100ccc8c001a16cc40387a0e5f974453ddbd92cdba4aac8549aebd78feab176c249022051a52708d06b149a5bffcc3ee612e0787431e673bfc79a43223cf05265ad7ae9"
}

New interface:
{
    event_origin: string | null;
    event_price: number | null;
    event_stamp: number | null;
    event_type: string;
    latest_origin: string;
    latest_price: number;
    latest_stamp: number;
    quote_origin: string;
    quote_price: number;
    quote_stamp: number;
}
*/
